import { createContext } from "react";

const SuppliarContext = createContext({});

export default SuppliarContext;
